import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "card-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_SparePartTypeList = _resolveComponent("SparePartTypeList")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component", _ctx.componentName]),
    part: _ctx.componentName
  }, [
    (_ctx.isReady && _ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Card, {
            class: "mb-4",
            icon: _ctx.componentOptions.icon && 'wrench',
            header: _ctx.t('SparePartsType', true),
            "use-markup": _ctx.componentOptions.card
          }, {
            list: _withCtx(() => [
              (_ctx.partTypes?.length)
                ? (_openBlock(), _createBlock(_component_SparePartTypeList, {
                    key: 0,
                    "part-types": _ctx.partTypes,
                    "current-part-type": _ctx.currentPartType,
                    onClickItem: _ctx.setPartType
                  }, null, 8, ["part-types", "current-part-type", "onClickItem"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_Message, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('NoSparePartTypes')), 1)
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }, 8, ["icon", "header", "use-markup"])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}